module.exports = function() {
  return new Worker(__webpack_public_path__ + "e1e346b0483ce3750b34.worker.js");
};